export const checkAuthorization = (securityService, {
	authorizePattern, 
	authorizeAction, 
	authorizeActionOrPattern, 
	authorizeActionScope 
}) => {

	let isAllowed = false;

	if(authorizePattern !== undefined) {
		isAllowed = securityService.isPatternAllowed(authorizePattern);
	}
	else if(authorizeAction!== undefined) {
		isAllowed = securityService.isActionAllowed(authorizeAction);
	}
	else if(authorizeActionOrPattern !== undefined) {
		isAllowed = securityService.isActionOrPatternAllowed(authorizeActionOrPattern);
	}
	else if(authorizeActionScope !== undefined) {
		isAllowed = securityService.isActionScopeAllowed(authorizeActionScope);
	}

	return isAllowed;
};